module.exports = __webpack_public_path__ + "images/mortgage.32af7274d66851b993823fcd3e2d04de.svg";